import { createApiHandler } from './handler';

const checkout = {
  apiClient: null,
  path: '/franchises/checkout',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async calculateShippingPrice(id) {
    try {
      const response = await this.apiClient.get(`${this.path}/${id}/calculate-shipping-price`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getSetupIntent() {
    try {
      const response = await this.apiClient.get(this.path + `/setup-intent`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async pay(form) {
    try {
      const response = await this.apiClient.post(this.path + `/pay`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default checkout;
